// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"index_maincontainer__TPKBs","page1":"index_page1__RzJua"};